import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {SET_TASK_CONFIGURATION} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import loadingCall from "../helpers/loadingCall";
import getTaskConfiguration from "./getTaskConfiguration";

const setTaskConfiguration= (formValues) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/setTaskConfiguration', formValues.hasTask ? formValues : {hasTask: formValues.hasTask}));
  handleResponse(dispatch, response, SET_TASK_CONFIGURATION, data => onSuccessPayload(data, getState), null, [getTaskConfiguration]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].bulkSignatureConfigurationSaved);
};
export default setTaskConfiguration;